import type { ForFunctionsToReduceSelectedIds } from '@entities/common/IdsSelector/types';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const idsSelectors = createSlice({
  name: 'common/idsSelectors',
  initialState: {
    isSelecting: {} as Record<string, boolean>,
    selectedIds: {} as Record<string, number[]>,
    excludedIds: {} as Record<string, number[]>,
    isNeedToSelectAll: {} as Record<string, boolean>,
  },
  reducers: {
    setIsSelecting: (state, action: PayloadAction<{ name: string; isSelecting: boolean }>) => {
      const hash = state.isSelecting;
      const entityName = action.payload.name;

      hash[entityName] = action.payload.isSelecting;
    },
    addSelectedId: (state, action: PayloadAction<ForFunctionsToReduceSelectedIds>) => {
      const massName = action.payload.name;
      const hash = state.selectedIds;
      const id = action.payload.id;

      !hash[massName] && (hash[massName] = []);
      hash[massName].push(id);
    },
    removeSelectedId: (state, action: PayloadAction<ForFunctionsToReduceSelectedIds>) => {
      if (state.selectedIds[action.payload.name]) {
        state.selectedIds[action.payload.name] = state.selectedIds[action.payload.name].filter(
          (id: number) => id !== action.payload.id
        );
      }
    },
    addExcludedId: (state, action: PayloadAction<ForFunctionsToReduceSelectedIds>) => {
      const massName = action.payload.name;
      const hash = state.excludedIds;
      const id = action.payload.id;

      !hash[massName] && (hash[massName] = []);
      hash[massName].push(id);
    },
    removeExcludedId: (state, action: PayloadAction<ForFunctionsToReduceSelectedIds>) => {
      state.excludedIds[action.payload.name] = state.excludedIds[action.payload.name].filter(
        (id: number) => id !== action.payload.id
      );
    },
    resetSelectedId: (state, action: PayloadAction<{ name: string; newIds: number[] }>) => {
      const massName = action.payload.name;
      const newIds = action.payload.newIds;
      const hash = state.selectedIds;

      state.selectedIds[action.payload.name] = newIds;

      newIds.length === 0 && delete hash[massName];
    },

    resetExcludedId: (state, action: PayloadAction<{ name: string; newIds: number[] }>) => {
      const massName = action.payload.name;
      const newIds = action.payload.newIds;
      const hash = state.excludedIds;

      state.excludedIds[action.payload.name] = newIds;

      newIds.length === 0 && delete hash[massName];
    },

    setIsNeedToSelectAll: (
      state,
      action: PayloadAction<{ name: string; isNeedToSelectAll: boolean }>
    ) => {
      const hash = state.isNeedToSelectAll;
      const entityName = action.payload.name;

      hash[entityName] = action.payload.isNeedToSelectAll;
    },
  },
});
export const idsSelectorsReducer = idsSelectors.reducer;
export const {
  removeSelectedId,
  resetSelectedId,
  addSelectedId,
  addExcludedId,
  removeExcludedId,
  setIsSelecting,
  setIsNeedToSelectAll,
  resetExcludedId,
} = idsSelectors.actions;
